export default "__VITE_ASSET__B0DwCPs9__"